import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Bot, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-brand-ink px-4">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 md:p-10">
        <div className="flex items-center gap-2">
          <span className="grid place-items-center h-10 w-10 rounded-lg bg-brand-navy text-white"><Bot className="h-5 w-5" /></span>
          <span className="font-display font-extrabold text-brand-ink">Admin Console</span>
        </div>
        <h1 className="mt-6 font-display font-bold text-2xl text-brand-ink">Sign in</h1>
        <p className="mt-1 text-sm text-muted-foreground">Manage products, content and enquiries.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label htmlFor="login-email">Email</Label><Input id="login-email" type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
          <div><Label htmlFor="login-password">Password</Label><Input id="login-password" type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={submitting} className="w-full bg-brand-navy hover:bg-brand-navy/90 text-white" data-testid="login-submit">
            {submitting ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Signing in…</> : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
